/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const ResetIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M0.314516 0.419361H0.576613C0.750304 0.419361 0.891128 0.560185 0.891128 0.733877V3.21397C2.02328 1.28551 4.12118 -0.00746354 6.52078 3.24212e-05C10.0954 0.0112239 13.0056 2.93573 13 6.51038C12.9944 10.0955 10.0864 13 6.5 13C4.82452 13 3.29712 12.3661 2.14453 11.325C2.01052 11.204 2.0042 10.9958 2.13189 10.8681L2.31717 10.6828C2.43519 10.5648 2.62511 10.5593 2.74916 10.6709C3.74227 11.5647 5.05676 12.1089 6.5 12.1089C9.58603 12.1089 12.1089 9.61028 12.1089 6.5C12.1089 3.41397 9.61027 0.891135 6.5 0.891135C4.32821 0.891135 2.44439 2.12501 1.51259 3.93146H4.08871C4.2624 3.93146 4.40322 4.07228 4.40322 4.24597V4.50807C4.40322 4.68176 4.2624 4.82258 4.08871 4.82258H0.314516C0.140825 4.82258 0 4.68176 0 4.50807V0.733877C0 0.560185 0.140825 0.419361 0.314516 0.419361Z"
        fill={color}
      />
    </svg>
  );
};
